export class Layer {

    /*----- required values ------*/

    id: string;
    serviceId: string;
    name: string;
    title: string;
    /* order -> used for ordering layers 0 -> base layer */
    order: number;
    /* there are 2 types: Layer
    * if type = layer, it's a simple layer.
    */
    type: string;
    /* visible when loaded the map */
    active: boolean;
    isInlayerMenu: boolean;
    /*number between 0 and 100, if not specified then is always 0*/
    opacity: number;
}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/models/layer.model.ts